import { render, staticRenderFns } from "./AppCalendar.vue?vue&type=template&id=e4b79ed2&"
import script from "./AppCalendar.vue?vue&type=script&lang=js&"
export * from "./AppCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports